import React from 'react';

import { Heading, Text } from '@eluve/components';
import { useTenantIdFromParams } from '@eluve/session-helpers';

import { TenantLlmOutputs } from './components/TenantLlmOutputs';

export const AdminTenantLlmOutputsPage: React.FC = () => {
  const tenantId = useTenantIdFromParams()!;

  return (
    <div className="grid gap-2">
      <div>
        <Heading size="2xl" weight="semibold">
          LLM Outputs
        </Heading>
        <Text>
          Control which output types this organization will be able to generate
        </Text>
      </div>
      <TenantLlmOutputs tenantId={tenantId} />
    </div>
  );
};
